<template>
    <div class="quality-main-section">
        <div class="container">
            <div class="column-container">
                <div class="col-left">
                    <div class="quality-section-title">
                        <h2>{{ qualityPage.quality_title }}</h2>
                    </div>
                    <div class="col-desc" v-html="qualityPage.quality_desc"></div>
                </div>
                <div class="col-right">
                    <div class="col-img" :style="'background-image: url(' + qualityPage.quality_img + ')'"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    // import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'quality-main-section',
        components: {
            // svgIcon,
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            qualityPage: 'loadQualityPage',
        }),
        methods: {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/quality/quality-main.scss';
    @import '@/styles/components/quality/respond/respond-quality-main.scss';
    // @import '@/styles/components/about/respond/about-us-section-respond.scss';
</style>